module.exports = __webpack_public_path__ + "img/416.c3d24817.jpg";